export default function ReadyToKnow() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 via-teal-700 to-slate-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold mb-6">
          Ready to Know Your App's Real Potential?
        </h2>
        <p className="text-xl md:text-2xl text-teal-100 mb-12 max-w-3xl mx-auto leading-relaxed">
          Get clarity, direction, and an intelligence-backed roadmap — without backend access or complicated setup.
        </p>

        <a
          href="/submit-app"
          className="inline-flex items-center gap-3 px-10 py-5 bg-white text-teal-700 font-bold text-lg rounded-xl hover:bg-slate-100 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap"
        >
          Start Evaluation
          <i className="ri-arrow-right-line text-2xl"></i>
        </a>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-teal-100">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-2xl"></i>
            <span className="text-sm font-semibold">No Backend Access Required</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-sm font-semibold">Results in 24-48 Hours</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-file-text-line text-2xl"></i>
            <span className="text-sm font-semibold">Downloadable PDF Report</span>
          </div>
        </div>
      </div>
    </section>
  );
}
